<template>
    <v-layout row wrap>
        <template v-if="taxes==='19'">
            <v-flex xs12 md6>
                <s-price-field
                        v-model="data.brutto"
                        :label="__('invoices.brutto_sum') + ' '+label"
                        :rules="rules"
                        @input="updateNetto"
                >
                </s-price-field>
            </v-flex>
            <v-flex xs12 md6>
                <s-price-field
                        v-model="data.netto"
                        :label="__('invoices.netto_sum') + ' '+label"
                        readonly
                        disabled
                        @input="calculateSum"
                >
                </s-price-field>
            </v-flex>
        </template>
        <v-flex xs12 v-else>
            <s-price-field
                    v-model="data.brutto"
                    :label="label"
                    :rules="rules"
                    @input="calculateSum"
            >
            </s-price-field>
        </v-flex>
    </v-layout>
</template>

<script>
    import {mapState} from 'vuex'
    import {mapActions} from 'vuex'

    export default {
        name: "TravelingExpenseField",
        props: {
            data: Object,
            label: String,
            rules: Array
        },
        computed: {
            ...mapState('form', [
                'taxes',
            ]),
        },
        methods: {
            ...mapActions('form', [
                'calculateSum'
            ]),
            updateNetto() {
                this.data.netto = Math.round(this.data.brutto / (1 + this.data.taxes / 100));
                this.calculateSum();
            }
        },
        watch: {
            taxes(value) {
                this.updateNetto();
            }
        }
    }
</script>

<style scoped>

</style>
